module.exports = __webpack_public_path__ + "static/media/sunglasses.4ace6ed2.svg";